import { withInstall } from '../utils/type';
import ThemeEditor from './ThemeEditor.js';
import ThemeProvider from './ThemeProvider';
export { default as useThemeStore } from './store';
export { default as ThemeProvider } from './ThemeProvider';
export { default as ThemeEditor } from './ThemeEditor.js';
export default withInstall(ThemeProvider, ThemeEditor);